import labels from "../../utils/labels";
import KPITextLine from "../UI/kpi/KPITextLine";
import KpiCard from "./KpiCard";
import { ReactComponent as BriefcaseIcon } from "../../assets/icons/briefcase.svg";
import kpiStyles from "../../styles/UI/kpiPage.module.css";
import { KpiWorkTime } from "../../types/kpi";
import {
  formatMinutes,
  formatSignedMinutes,
} from "../../utils/durationFormatUtil";

const WorkTimeCard = ({ kpiList }: { kpiList: KpiWorkTime }) => {
  return (
    <KpiCard
      title="Arbejdstid"
      icon={<BriefcaseIcon />}
      classes="w-[30%] max-w-[430px]"
    >
      <div className="flex flex-col gap-[50px]">
        <div className="flex gap-spacing-xl justify-center mt-[25px]">
          {/* The vagtplan already includes added work time; the top part shows how much of it was added in Pondoo. */}
          <div className={kpiStyles.graphBars}>
            {kpiList.manualWorkTimePercent > 0 && (
              <div
                style={{
                  height: `${kpiList.manualWorkTimePercent}%`,
                  backgroundColor: "var(--col-error-primary)",
                  border: "2px solid var(--col-error-3)",
                }}
              ></div>
            )}
            {kpiList.shiftPercent > 0 && (
              <div
                className={kpiStyles.individualGraphBars}
                style={{
                  height: `${kpiList.shiftPercent}%`,
                  backgroundColor: "var(--col-graph-second)",
                  border: "2px solid var(--col-graph-second-2)",
                }}
              ></div>
            )}
          </div>
          <div className={kpiStyles.graphBars}>
            {kpiList.unplannedPercent > 0 && (
              <div
                className={kpiStyles.individualGraphBars}
                style={{
                  height: `${kpiList.unplannedPercent}%`,
                  backgroundColor: "var(--col-warning-2)",
                  border: "2px solid var(--col-warning-primary)",
                }}
              ></div>
            )}
            {kpiList.drivingPercent > 0 && (
              <div
                className={kpiStyles.individualGraphBars}
                style={{
                  height: `${kpiList.drivingPercent}%`,
                  backgroundColor: "var(--col-graph-first)",
                  border: "2px solid var(--col-graph-first-1)",
                }}
              ></div>
            )}
            {kpiList.plannedPercent > 0 && (
              <div
                className={kpiStyles.individualGraphBars}
                style={{
                  height: `${kpiList.plannedPercent}%`,
                  backgroundColor: "var(--col-graph-third)",
                  border: "2px solid var(--col-graph-third-1)",
                }}
              ></div>
            )}
          </div>
        </div>
        <div className="flex flex-col gap-spacing-xl">
          <KPITextLine
            compare={false}
            title={labels.plan}
            tooltipText={labels.shiftTimeTooltip}
            value={formatMinutes(kpiList.shiftMinutes)}
            color="var(--col-graph-second)"
            borderColor="var(--col-graph-second-2)"
          />
          <KPITextLine
            compare={false}
            title={labels.manualWorkTime}
            tooltipText={labels.manualWorkTimeTooltip}
            value={formatSignedMinutes(kpiList.manualWorkTimeMinutes)}
            color="var(--col-error-primary)"
            borderColor="var(--col-error-3)"
          />
          <KPITextLine
            compare={false}
            title={labels.unplannedTime}
            tooltipText={labels.unplannedWorkTimeTooltip}
            value={formatMinutes(kpiList.unplannedMinutes)}
            color="var(--col-warning-2)"
            borderColor="var(--col-warning-primary)"
          />
          <KPITextLine
            compare={false}
            title={labels.transportationTime}
            tooltipText={labels.drivingTimeTooltip}
            value={formatMinutes(kpiList.drivingMinutes)}
            color="var(--col-graph-first)"
            borderColor="var(--col-graph-first-1)"
          />
          <KPITextLine
            compare={false}
            title={labels.plannedTime}
            tooltipText={labels.plannedWorkTimeTooltip}
            value={formatMinutes(kpiList.plannedMinutes)}
            color="var(--col-graph-third)"
            borderColor="var(--col-graph-third-1)"
          />
        </div>
      </div>
    </KpiCard>
  );
};

export default WorkTimeCard;
